import { Box, Typography } from '@mui/material';

const columns = (renderValueCell) => [
  {
    field: 'fromFluidId',
    headerName: 'From',
    flex: 1,
    editable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'toFluidId',
    headerName: 'To',
    flex: 1,
    editable: false,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'pumps_output',
    headerName: 'Pumps Output (bbl/stk)',
    renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Pumps Output
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
          (bbl/stk)
          </Typography>
        </Box>
    ),
    flex: 1,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'pumps_spm',
    headerName: 'Total SPM (spm)',
    renderHeader: () => (
          <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Total SPM
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            ({'spm'})
          </Typography>
          </Box>
    ),
    flex: 1,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
];
export default columns;
